// Aucun cache de résultats : partage uniquement les lectures identiques en cours.
// Les appels annulables et les anciennes routes GET qui déclenchent des actions
// conservent chacun leur requête et leur cycle de vie.
export function installSingleFlightReads(instance, sessionKey) {
  const pending = new Map();
  const get = instance.get.bind(instance);
  let revision = 0;
  instance.interceptors.request.use(config => {
    if (['post','put','patch','delete'].includes(String(config.method).toLowerCase())) {
      revision += 1;
      pending.clear();
    }
    return config;
  });
  instance.get = (url, config = {}) => {
    const pathname = String(url).split('?')[0].replace(/^\//,'');
    const safe = /^(?:client\/freelance|tempworker-candidate\/freelance|quotation\/freelance|order\/freelance|document\/prefecture-controls|professions|qualifications)(?:\/|$)/.test(pathname);
    if (!safe || config.signal || config.cancelToken || config.paramsSerializer || config.adapter || config.transformResponse || config.auth || config.validateStatus) return get(url, config);
    const key = JSON.stringify([sessionKey(), revision, instance.getUri({url,...config}), config.responseType || 'json', config.headers || {}, config.timeout,config.withCredentials]);
    if (pending.has(key)) return pending.get(key);
    const request = get(url,config);
    pending.set(key,request);
    const clear = () => {if(pending.get(key) === request) pending.delete(key);};
    request.then(clear,clear);
    return request;
  };
}
